import React from 'react'
import cx from 'classnames';
import { IKeldanApiPricingViewModel } from '../../types/HomeTypes';
import { formatNumber } from '../../services/utils';

interface IProps {
    groups: IKeldanApiPricingViewModel | null,
    className?: string,
}

const SubscriptionPricingTable: React.FC<IProps> = ({
    groups,
    className
}) => {
    
    groups?.products?.find(priceprod => priceprod.name === "Annað")?.entries?.sort((a, b) => {
        if (a.entryName === null && b.entryName === null) return 0;
        if (a.entryName === null) return 1;
        if (b.entryName === null) return -1;
        if(a.entryName < b.entryName) return -1;
        if(a.entryName > b.entryName) return 1;
        return 0;
    });
    groups?.products?.find(priceprod => priceprod.name === "Hlutafélagaskrá")?.entries?.sort((a, b) => {
        if (a.entryName === null && b.entryName === null) return 0;
        if (a.entryName === null) return 1;
        if (b.entryName === null) return -1;
        if (a.entryName < b.entryName) return -1;
        if (a.entryName > b.entryName) return 1;
        return 0;
    })
    
    return (
        <div className={cx('KCL_subscription-pricing-table', className)}>
            <table>
                <colgroup>
                    <col />
                    <col />
                    <col className="highlight" />
                </colgroup>

                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>stök skýrsla</th>
                        <th>Áskrift</th>
                    </tr>
                </thead>

                <tfoot>
                    <tr>
                        <td colSpan={2}>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                </tfoot>

                {groups && groups.products.map((item,index) => (
                    <tbody key={'table' + index}>
                        <tr key={index}>
                            <td colSpan={2}><strong>{item.name}</strong></td>
                            <td>&nbsp;</td>
                        </tr>

                        {item.entries && item.entries.map((entryItem, ind) => (
                            <tr key={ind}>
                                <td>{entryItem.entryName}</td>
                                <td>
                                    <div className={cx('flex items-center justify-center')}>
                                        <span>
                                            {(entryItem.freePrice !== 0) 
                                                ? formatNumber(entryItem.freePrice, '-', 0)?.replace(',' , '.') + ' kr.'
                                                : "Frítt"
                                            }
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div className={cx('flex items-center justify-center')}>
                                        <span>
                                            {(entryItem.subPrice !== 0) 
                                                ? (formatNumber(entryItem.subPrice, '-', 0)?.replace(',' , '.') + ' kr.')  
                                                : "Frítt"
                                            }
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ))}
            </table>
        </div>
    )
}

export default SubscriptionPricingTable
